import { useTranslation } from 'react-i18next';
import { Form, Switch, InputNumber } from 'antd';

// Absence-quota config for non-employment workers (service contract / author /
// supplementary / PP). This is the DEFINITION only — how many allowed days per
// kind (absence / sick / other). The actual day-by-day recording happens in the
// timesheet/calendar (not here). NOT a legal annual-leave entitlement.
//
// Renders inside the employee <Form>; field paths live under `specialAbsence`.
const ENABLED = ['specialAbsence', 'enabled'];

export const ABSENCE_TYPES = [
  { value: 'absence', key: 'absenceTypeAbsence', fallback: 'Odsustvo' },
  { value: 'sick', key: 'absenceTypeSick', fallback: 'Bolovanje' },
  { value: 'other', key: 'absenceTypeOther', fallback: 'Drugo' },
];

export default function SpecialAbsenceSection({ form, disabled }) {
  const { t } = useTranslation(['forms']);
  const enabled = Form.useWatch(ENABLED, form);

  return (
    <div className="mb-5 rounded border border-sky-200 bg-sky-50 p-4">
      <div className="mb-2 flex items-center gap-3">
        <span className="text-sm font-semibold text-sky-700">
          {t('specialAbsenceTitle', {
            ns: 'forms',
            defaultValue: 'Odsustva (van radnog odnosa)',
          })}
        </span>
        <Form.Item name={ENABLED} valuePropName="checked" noStyle>
          <Switch
            size="small"
            disabled={disabled}
            checkedChildren={t('on', { ns: 'forms', defaultValue: 'Da' })}
            unCheckedChildren={t('off', { ns: 'forms', defaultValue: 'Ne' })}
          />
        </Form.Item>
        <span className="text-[11px] text-sky-600">
          {t('specialAbsenceQuotaHint', {
            ns: 'forms',
            defaultValue:
              'Samo definicija kvote — evidentiranje se radi u kalendaru.',
          })}
        </span>
      </div>

      {enabled && (
        <div className="grid grid-cols-3 gap-3">
          {ABSENCE_TYPES.map((tt) => (
            <div
              key={tt.value}
              className="rounded border border-sky-100 bg-white p-2"
            >
              <label className="mb-1 block text-xs font-medium text-gray-600">
                {t(tt.key, { ns: 'forms', defaultValue: tt.fallback })}
              </label>
              <div className="flex items-center gap-2">
                <span className="text-[11px] text-gray-400">
                  {t('specialAbsenceAllowedPerYear', {
                    ns: 'forms',
                    defaultValue: 'Dozvoljeno dana/god.',
                  })}
                </span>
                <Form.Item
                  name={['specialAbsence', 'limits', tt.value]}
                  className="!mb-0"
                >
                  <InputNumber min={0} disabled={disabled} className="w-20" />
                </Form.Item>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
